export default __webpack_public_path__ + "static/media/billboard.e22a472f.jpg";